var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FCF5F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6162 15.6409C22.6736 13.802 25.3268 13.802 26.3841 15.6409L34.4271 29.6287C35.4813 31.462 34.1579 33.7495 32.0431 33.7495H15.9572C13.8424 33.7495 12.5191 31.462 13.5732 29.6287L21.6162 15.6409ZM25.0838 16.3886C24.6032 15.5527 23.3972 15.5527 22.9165 16.3886L14.8736 30.3764C14.3944 31.2097 14.9959 32.2495 15.9572 32.2495H32.0431C33.0044 32.2495 33.6059 31.2097 33.1267 30.3764L25.0838 16.3886Z",
    fill: "#D07200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0002 20.2495C24.4144 20.2495 24.7502 20.5852 24.7502 20.9995V24.9995C24.7502 25.4137 24.4144 25.7495 24.0002 25.7495C23.5859 25.7495 23.2502 25.4137 23.2502 24.9995V20.9995C23.2502 20.5852 23.5859 20.2495 24.0002 20.2495Z",
    fill: "#D07200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5119 28.4409C24.8198 28.718 24.8447 29.1922 24.5676 29.5001L24.5576 29.5112C24.2805 29.8191 23.8063 29.844 23.4984 29.5669C23.1906 29.2898 23.1656 28.8156 23.4427 28.5077L23.4527 28.4966C23.7298 28.1887 24.204 28.1638 24.5119 28.4409Z",
    fill: "#D07200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.9e45234bb124f049389951f0efa5d400.svg";
export { ForwardRef as ReactComponent };